import { RoutePermittedRole } from "shared/constants/AppConst";
import CompanyOverviewPage from "./companyOverview/CompanyOverviewPage";
import FinancialInformationPage from "./financialInformation/FinancialInformationPage";
import GrowthRoadmapPage from "./growthRoadmap/GrowthRoadmapPage";
import OurPartnersPage from "./ourPartners/OurPartnersPage";
import GlobalIndustryPage from "./globalIndustry/GlobalIndustryPage";
import DocumentsPage from "./documents/DocumentsPage";
import OurTeamPage from "./ourTeam/OurTeamPage";

export const investorDeskMasterConfig = [
  {
    permittedRole: RoutePermittedRole.User,
    path: "/investorDesk/company-overview",
    exact: true,
    element: <CompanyOverviewPage />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: "/investorDesk/our-team",
    exact: true,
    element: <OurTeamPage />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: "/ourTeam",
    exact: true,
    element: <OurTeamPage />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: "/investorDesk/financial-information",
    exact: true,
    element: <FinancialInformationPage />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: "/investorDesk/growth-roadmap",
    exact: true,
    element: <GrowthRoadmapPage />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: "/investorDesk/our-partners",
    exact: true,
    element: <OurPartnersPage />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: "/investorDesk/global-industry",
    exact: true,
    element: <GlobalIndustryPage />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: "/investorDesk/documents",
    exact: true,
    element: <DocumentsPage />,
  },
];
